import { titleColor } from './common'

/** 当月订单前五 */
export default data => {
  const dataSource = [['shop_name', 'count']].concat(data.map(i => [i.x, i.y]))
  return {
    title: {
      text: '当月订单量排名 Top5',
      textStyle: {
        color: titleColor,
        fontSize: 30,
        fontWeight: 'bold'
      }
    },
    grid: {
      top: '20%',
      right: '10%',
      bottom: '10%'
    },
    textStyle: {
      color: '#fff',
      fontSize: 20,
      fontWeight: 'bold'
    },
    dataset: {
      source: dataSource
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    yAxis: {
      type: 'value',
      name: '订单量',
      nameTextStyle: {
        fontSize: 20,
        fontWeight: 'bold'
      },
      axisLabel: {
        fontSize: 20,
        fontWeight: 'bold'
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#142346'
        }
      }
    },
    xAxis: {
      type: 'category',
      name: '店铺',
      nameTextStyle: {
        fontSize: 20,
        fontWeight: 'bold'
      },
      axisLabel: {
        fontSize: 20,
        fontWeight: 'bold'
      }
    },
    series: [
      {
        type: 'bar',
        barMaxWidth: '30',
        label: {
          show: true,
          fontSize: 20,
          fontWeight: 'bold'
        },
        encode: {
          y: 'count',
          x: 'shop_name'
        }
      }
    ]
  }
}
